//manage all the endpoints
import adviserdashboard_api from './adviserdashboard_api';
import funddashboard_api from './funddashboard_api';
import bo_api from './bo_api';

export default {    
    adviserdashboard_api,
    funddashboard_api,
    bo_api,
    //....
}